import { MOCK_CONTACT } from './MockContact'

export const MOCK_METERS = [
  {
    _created_at: '2025-05-07T11:40:35.712Z',
    _id: '3c95352d-32e2-486d-9991-d565f3b84e11',
    _org: 'test-org',
    _schema: 'meter',
    _tags: [],
    _title: '1ESY2158347841311',
    _updated_at: '2025-05-23T06:18:09.077Z',
    calibration_date: '2025-01-01',
    customer: [MOCK_CONTACT],
    direction: 'feed-in',
    location: 'Werkstatt',
    ma_lo_id: 'DE228554800',
    manufacturer: 'EMH',
    meter_number: '1ESY2158347841311',
    meter_type: 'smart-meter',
    obis_number: '2-3:6.8.9',
    sector: 'power',
    status: 'active',
    tariff_type: 'et',
    transformer_ratio: '1',
    unit: 'kWh',
    used_for: 'Haushaltsstrom'
  },
  {
    _created_at: '2025-05-19T11:40:47.144Z',
    _id: 'e250a873-fe35-4b24-b502-19a84347200d',
    _org: 'test-org',
    _schema: 'meter',
    _tags: ['dont-touch'],
    _title: '1ESY6311780912661',
    _updated_at: '2025-06-17T11:03:26.779Z',
    calibration_date: '2025-01-01',
    customer: [MOCK_CONTACT],
    direction: 'feed-out',
    location: 'Keller Oben Mitte',
    ma_lo_id: 'DE852287503',
    manufacturer: 'Sagemcom',
    meter_number: '1ESY6311780912661',
    meter_type: 'electronic-meter',
    obis_number: '1-0:1.8.0',
    sector: 'power',
    status: 'active',
    tariff_type: 'et',
    transformer_ratio: '1',
    unit: 'kWh',
    used_for: 'Haushaltsstrom'
  },
  {
    _created_at: '2025-04-22T11:09:20.751Z',
    _id: '571f64fc-ed24-4da5-8026-2bbaabe84065',
    _org: 'test-org',
    _schema: 'meter',
    _tags: [],
    _title: '123123123',
    _updated_at: '2025-05-15T14:22:18.456Z',
    calibration_date: '2024-12-01',
    customer: [MOCK_CONTACT],
    direction: 'feed-in',
    location: 'Basement',
    ma_lo_id: '1231231231',
    manufacturer: 'Elster',
    meter_number: '123123123',
    meter_type: 'bellow-gas-meter',
    obis_number: '123123123',
    sector: 'gas',
    status: 'active',
    tariff_type: 'nt',
    transformer_ratio: '1',
    unit: 'm³',
    used_for: 'Heating'
  },
  {
    _created_at: '2025-03-10T09:25:12.345Z',
    _id: 'a4b5c6d7-e8f9-0123-4567-890abcdef123',
    _org: 'test-org',
    _schema: 'meter',
    _tags: ['solar'],
    _title: 'SOL789456123',
    _updated_at: '2025-06-01T10:18:33.678Z',
    calibration_date: '2024-11-15',
    customer: [MOCK_CONTACT],
    direction: 'feed-out',
    location: 'Roof Installation',
    ma_lo_id: 'DE445566778',
    manufacturer: 'SMA',
    meter_number: 'SOL789456123',
    meter_type: 'solar-meter',
    obis_number: '1-0:2.8.0',
    sector: 'solar',
    status: 'active',
    tariff_type: 'et',
    transformer_ratio: '1',
    unit: 'kWh',
    used_for: 'Solar Production'
  },
  {
    _created_at: '2025-02-14T13:45:27.890Z',
    _id: 'b8c9d0e1-f2a3-4567-8901-bcdef0123456',
    _org: 'test-org',
    _schema: 'meter',
    _tags: ['heating'],
    _title: 'HEAT654321987',
    _updated_at: '2025-05-20T16:30:45.234Z',
    calibration_date: '2024-10-01',
    customer: [MOCK_CONTACT],
    direction: 'feed-in',
    location: 'Heating Room',
    ma_lo_id: 'DE998877665',
    manufacturer: 'Viessmann',
    meter_number: 'HEAT654321987',
    meter_type: 'heat-meter',
    obis_number: '6-0:1.0.0',
    sector: 'heating',
    status: 'active',
    tariff_type: 'nt',
    transformer_ratio: '1',
    unit: 'kWh',
    used_for: 'Heat Pump'
  },
  {
    _created_at: '2025-01-08T11:20:15.567Z',
    _id: 'c2d3e4f5-6789-0abc-def1-23456789abcd',
    _org: 'test-org',
    _schema: 'meter',
    _tags: ['water'],
    _title: 'WAT987654321',
    _updated_at: '2025-04-25T08:45:33.123Z',
    calibration_date: '2024-09-01',
    customer: [MOCK_CONTACT],
    direction: 'feed-in',
    location: 'Utility Room',
    ma_lo_id: 'DE112233445',
    manufacturer: 'Kamstrup',
    meter_number: 'WAT987654321',
    meter_type: 'water-meter',
    obis_number: '7-0:3.0.0',
    sector: 'water',
    status: 'maintenance',
    tariff_type: 'et',
    transformer_ratio: '1',
    unit: 'm³',
    used_for: 'Water Supply'
  }
]
